import React from 'react';
import clsx from 'clsx';
import Fade from '../fade/fade';
import useControls from './_hooks/use-controls';
import styles from './player-info.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  open?: boolean;
}

export const PlayerInfo: React.FC<Props> = (props: Props) => {
  const { children, open = false, className, ...rest } = props;

  const { handlePlayerControlsMouseEnter, handlePlayerControlsMouseLeave } = useControls();

  return (
    <Fade in={open} unmountOnExit>
      <div
        className={clsx(styles['player-info'], className)}
        onMouseEnter={handlePlayerControlsMouseEnter}
        onMouseLeave={handlePlayerControlsMouseLeave}
        {...rest}
      >
        {children}
      </div>
    </Fade>
  );
};

export default React.memo(PlayerInfo);
